
<div class="app-container">
    <app-aside></app-aside>
    <section class="body-container" [ngClass]="[_cs.slideOpen ? 'iconn-bar-width-class' : 'nor-bar-width', _cs.expandMenu ? 'expand-menu' : '' ]"
        #bodyContainer>
        <app-header></app-header>
        <div [ngClass]="[_cs.expandMenu ? 'inactive-body' : '' ]" (click) = 'onClickOutside()'></div>
            <app-title [ngClass]="{'d-none': _cs.ReceivingMenu === _cs.ReceivingRouteUrl }" [options]="_cs.titleOptions" (deleteEvent)="_cs.deleteClick($event)" (backEvent)="_cs.backClick($event)" (titleClickEvent)='_cs.titleClick($event)'
                (actionEvent)="_cs.actionClick($event)" (voiceAssistantActionEvent)="_cs.voiceAssistantActionClick($event)" (loadReq)="_cs.loadReq($event)" (loadReqApproved)="_cs.loadSaved($event)"
                (editEvent)="_cs.editClick($event)" (MoreOptionsClicked)="_cs.moreOptionClick($event)" (mailEvent) ="_cs.sendMailClick($event)"
                (loadRequisitionEvent)="_cs.loadRequisitionEvent($event)" (syncClicked)="_cs.syncClicked($event)" (reconcile)="_cs.reconcile($event)">
            </app-title>
            <div class='filter-overlay' #filterOverlay></div>
            <div [ngStyle]="_cs.ReceivingMenu === _cs.ReceivingRouteUrl && {'height': '100%', 'padding-bottom': '0'}"  #appcontainer id="app-container" class="section-container" (click)="onClickOutside()" (scroll)="onScroll($event)" 
            #sectionContainer [ngClass]="{'setting-height': isLoginSetting,'sectionContainerHideHeader': !showAppHeader,'showReleaseNotes':showReleaseNotes,'offlineContainer':offlineTab} ">
                <router-outlet></router-outlet>
            </div>
        
    </section>
</div>

<app-spinner class="loading" name="loading">{{'common.loading' | translate }}...</app-spinner>
